import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'
import { Map, Set, Record } from 'immutable'
import * as actions from './actions'

const currentUpdateRequestId = handleActions({
  [combineActions(
    actions.requestBulkUpdate,
    actions.requestBulkUpdateFailed,
    actions.requestBulkUpdateSuccess,
  )]: (state, action) => {
    const { updateRequestId } = action.payload
    return updateRequestId
  },
}, null)

const updateRequestsById = handleActions({
  [combineActions(
    actions.requestBulkUpdate,
    actions.receiveBulkUpdate,
  )]: (state, action) => {
    const { updateRequestId, inboxId, updaterId, conversationIds, conversationStatus } = action.payload

    if (state.get(updateRequestId)) {
      return state
    }

    const bulkUpdateRequest = Record({
      id: updateRequestId,
      inboxId,
      updaterId,
      conversationIds,
      conversationStatus,
    })()

    return state.set(updateRequestId, bulkUpdateRequest)
  },
  [combineActions(
    actions.requestBulkUpdateSuccess, // Use server-generated ID
  )]: (state, action) => {
    const { tempUpdateRequestId, updateRequestId } = action.payload

    const bulkUpdateRequest = state
      .get(tempUpdateRequestId)
      .set('id', updateRequestId)

    return state
      .delete(tempUpdateRequestId)
      .set(updateRequestId, bulkUpdateRequest)
  },
}, Map())

const statusByUpdateRequestId = handleActions({
  [combineActions(
    actions.requestBulkUpdatePending,
    actions.requestBulkUpdateFailed,
    actions.receiveBulkUpdatePending,
    actions.receiveBulkUpdateFailed,
    actions.receiveBulkUpdateSuccess,
  )]: (state, action) => {
    const { updateRequestId } = action.payload
    return state.set(updateRequestId, action.type)
  },
  [combineActions(
    actions.requestBulkUpdateSuccess,  // Use server-generated ID
  )]: (state, action) => {
    const { tempUpdateRequestId, updateRequestId } = action.payload
    return state
      .delete(tempUpdateRequestId)
      .set(updateRequestId, action.type)
  },
}, Map())

const updateRequestIdsByInboxId = handleActions({
  [combineActions(
    actions.requestBulkUpdate,
    actions.receiveBulkUpdate,
  )]: (state, action) => {
    const { inboxId, updateRequestId } = action.payload
    return state.update(inboxId, updateRequestIds => (updateRequestIds || Set()).add(updateRequestId))
  },
  [combineActions(
    actions.requestBulkUpdateSuccess,  // Use server-generated ID
  )]: (state, action) => {
    const { inboxId, tempUpdateRequestId, updateRequestId } = action.payload

    return state.update(inboxId, updateRequestIds => updateRequestIds
      .delete(tempUpdateRequestId)
      .add(updateRequestId))
  },
}, Map())

export default combineReducers({
  currentUpdateRequestId,
  updateRequestsById,
  statusByUpdateRequestId,
  updateRequestIdsByInboxId,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/bulkUpdate/reducer.js